import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

import VideoEditor from '../components/VideoEditor';
import FormFields from '../components/FormFields';
import { useLoader } from '../context/LoaderContext';
import { useToast } from '../context/ToastContext';
import api from '../api/axios';
import '../css/App.css';

import HeroBg from "../../src/images/hero-bg.png";
import { getUser } from '../api/auth';

const getDefaultSaleDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 2);
  return date.toISOString().split("T")[0];
};

const INITIAL_FORM_DATA = {
  layout1: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Nykaa',
    creative_name: 'Corkcicle Summer Review',
    canvas: {
      backgroundType: 'solid',
      backgroundColor: '#f1f1f1',
      textColor: "#121212",
      gradientColor1: '#f1f1f1',
      gradientColor2: '#ffffff',
      gradientAngle: 135,
      padding: '0px 30px'
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/nykaa.mp4',
      caption: "What's the longest your ice has lasted in your Corkcicle? Let us know in the comments!",
      hashtags: '#Summer #ProductReview #Corkcicle',
      likes: '125',
      comments: '4',
      shares: '6',
      width: 100,
      height: 100,
      shadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      shape: 'none'
    },
    profile: {
      username: 'Nykaa',
      following: '29',
      followers: '43.5K',
      likes: '70.1K',
      bio: 'This year we celebrated Galentine’s by doing what we love most, getting fully glammed… just to stay in together. We dipped into our @charlottetilbury favourites (because obviously) and turned our living room into a full glam studio. Soft glam, good coffee, better gossip and no boys allowed.',
      brandTitle: 'Nykaa'
    },
    brand: {
      logoUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-IkLTc2M-yEOJxU7n5c1b3KZXA-r2w5ix3-9owQo&usqp=CAE&s',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s'
    },
    product: {
      name: 'Lipstick',
      price: '$4.95',
      rating: 5,
      imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSx0dT0QOJv6aYIE7RKqsMQz89uzWF9KdyAZg&s',
    }
  },
  layout2: {
    camp_name: '',
    domain: 'https://www2.hm.com/',
    brand_name: 'H&M',
    creative_name: 'hm summer collection',
    canvas: {
      backgroundType: 'gradient',
      backgroundColor: '#4a735b',
      gradientColor1: '#4a735b',
      gradientColor2: '#33503e',
      gradientAngle: 135,
      padding: '0px'
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/h%26m.mp4',
      subtitle1: "Suit at the dentist's office?",
      subtitle2: 'Wear what makes you feel good.',
      width: 100,
      height: 100,
      shadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
      shape: 'rounded',
      likes: '155',
      comments: '20',
      shares: '38'
    },
    brand: {
      logoUrl: 'https://i.ibb.co/9mmj4sZL/h-m-removebg-preview-white.png',
      website: 'hm.com',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s',
      shopText: 'Shop Now'
    },
    background: {
      backgroundType: 'solid',
      color: '#1a4d3a',
      gradientColor1: '#1a4d3a',
      gradientColor2: '#0b2b20',
      gradientAngle: 135
    }
  },
  layout3: {
    camp_name: '',
    domain: 'https://www.ralphlauren.com/',
    brand_name: 'Ralph Lauren',
    creative_name: 'Ralph Lauren Summer Collection',
    canvas: {
      backgroundType: 'gradient',
      backgroundColor: '#042D44',
      gradientColor1: '#042D44',
      gradientColor2: '#1574C2',
      gradientAngle: 135,
      padding: '0px'
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/ralph_lauren.mp4'
    },
    brand: {
      name: 'Ralph Lauren',
      verified: true,
      followers: '331K',
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/ralph_lauren_logo.jpg',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s'
    },
    copy: {
      title: "Polo Ralph Lauren: Men's Outerwear",
      description: 'Rugged yet refined, #PoloRalphLauren leather and suede jackets are thoughtfully designed for durability and a timeless sartorial appeal.'
    },
    cta: {
      text: 'Shop Now',
      website: 'ralphlauren.com'
    }
  },
  layout4: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Myntra',
    creative_name: 'Corkcicle Summer Review',
    canvas: {
      backgroundType: 'solid',

      gradientColor1: '#f1f1f1',
      gradientColor2: '#ffffff',
      gradientAngle: 135,

      bottomBackgroundColor: '#ffffff',
      sideBackgroundColor: '#d66700',
      titleTextColor: "#121212",
      subTitleTextColor: "#ffffff",
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/layout4_input.mp4',
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/logo.png',
      qrCodeUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/qr.png'
    },
    titles: [
      'Experience the difference',
      'Design for you',
      'Precision meets luxury'
    ],
    subTitle: 'Crafted for those who value every second',
    products: [
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product1.png',
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product2.png',
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product3.png'
    ],
  },
  layout4B: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Myntra',
    creative_name: 'Corkcicle Summer Review',
    canvas: {
      backgroundType: 'solid',

      gradientColor1: '#f1f1f1',
      gradientColor2: '#ffffff',
      gradientAngle: 135,

      bottomBackgroundColor: '#ffffff',
      sideBackgroundColor: '#d66700',
      titleTextColor: "#121212",
      subTitleTextColor: "#ffffff",
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/layout4_input.mp4',
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/logo.png',
      qrCodeUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/qr.png'
    },
    titles: [
      'Experience the difference',
      'Design for you',
      'Precision meets luxury'
    ],
    subTitle: 'Crafted for those who value every second',
    products: [
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product1.png',
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product2.png',
      'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/product3.png'
    ],
  },
  layout4C: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Myntra',
    creative_name: 'Corkcicle Summer Review',

    saleDate: getDefaultSaleDate(),

    canvas: {
      backgroundType: 'gradient',
      backgroundColor: '#042D44',
      // gradientColor1: '#1574C2',
      // gradientColor2: '#042D44',
      gradientColor1: '#ff24ce',
      gradientColor2: '#4111ca',
      gradientAngle: 90,
      padding: '0px',

      titleTextColor: "#ffffff",
      subTitleTextColor: "#ffffff",
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/layout4_input.mp4',
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-4(lshape)/timer_logo.png',
    },
    title: 'INDIA BIGGEST BEAUTY SALE WITH THE BIGGEST BEAUTY SAVING',
    subTitle: 'GET THE BEST DEALS ON 1800+ BRANDS',
  },
  layout6: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Myntra',
    creative_name: 'Corkcicle Summer Review',
    canvas: {
      backgroundColor: '#793b22',
      titleTextColor: "#ffffff",
      borderColor: "#cca884",
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-6/video.webm',
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-6/logo.png',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s'
    },
    title: 'Conquer Every Moment',
    product: 'https://test-pages.b-cdn.net/SocialTV/layout-6/product1.png?v123',
  },
  layout7: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Myntra',
    creative_name: 'Corkcicle Summer Review',
    canvas: {
      backgroundColor: '#214F4F',
      textColor: "#ffffff",
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-7/video1.mp4',
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-6/logo.png',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s'
    },
    title: 'Conquer Every Moment',
    infoText: "Scan for 10% offer",
    products: [
      "https://test-pages.b-cdn.net/SocialTV/layout-7/product.png",
      "https://test-pages.b-cdn.net/SocialTV/layout-7/product1.png",
      "https://test-pages.b-cdn.net/SocialTV/layout-7/product2.png",
      "https://test-pages.b-cdn.net/SocialTV/layout-7/product3.png"
    ],
  },
  layout5: {
    camp_name: '',
    domain: 'https://www.nykaa.com/',
    brand_name: 'Best4Run',
    creative_name: 'The Best Running Shoes',
    canvas: {
      backgroundColor: '#214F4F',
      gradientColor1: '#478cfe',
      gradientColor2: '#55e07b',
      textColor: "#ffffff",
      discountTextColor: "#ebed1e"
    },
    video: {
      url: 'https://test-pages.b-cdn.net/SocialTV/layout-5/layout5_input.mp4',
      url2: "https://test-pages.b-cdn.net/SocialTV/layout-5/giphy.gif",
    },
    brand: {
      logoUrl: 'https://test-pages.b-cdn.net/SocialTV/layout-5/best4run_logo.png',
      qrCodeUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRksHXkD3EcuHsVe8GEwN-T4hqrznJq-cJktA&s'
    },
    title: 'Give your wardrobe a spring refresh',
    discountText: "Get 20% Off",
    infoText: "All our models",
    products: [
      "https://test-pages.b-cdn.net/SocialTV/layout-5/shoe2.png",
      "https://test-pages.b-cdn.net/SocialTV/layout-5/shoe1.png",
    ],
  },
};



export default function EditorPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const { layout } = location.state || {};

  const [selectedLayout, setSelectedLayout] = useState(layout || 'layout1');
  // const canvasWrapperRef = useRef(null);
  // const canvasContainerRef = useRef(null);
  // const [scale] = useState(1);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const { loaderStart, loaderClose } = useLoader();
  const { success, error } = useToast();

  const [errors, setErrors] = useState({})

  const DESIGN_WIDTH = 1200;
  const DESIGN_HEIGHT = 750;

  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const outer = document.querySelector(".canvas-outer");
      if (!outer) return;

      const { width, height } = outer.getBoundingClientRect();

      const scaleX = width / DESIGN_WIDTH;
      const scaleY = height / DESIGN_HEIGHT;

      setScale(Math.min(scaleX, scaleY));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const getCanvasBackground = (canvas) => {
    const type = canvas?.backgroundType || 'solid';
    if (type === 'gradient') {
      const angle = Number.isFinite(Number(canvas?.gradientAngle)) ? Number(canvas.gradientAngle) : 135;
      const c1 = canvas?.gradientColor1 || canvas?.backgroundColor || '#e0e0e0';
      const c2 = canvas?.gradientColor2 || '#ffffff';
      return `linear-gradient(${angle}deg, ${c1}, ${c2})`;
    }
    return canvas?.backgroundColor || '#e0e0e0';
  };

  const handleFormChange = (layout, section, field, value) => {
    setFormData((prev) => {
      // If section is null → update top-level field
      if (!section) {
        return {
          ...prev,
          [layout]: {
            ...prev[layout],
            [field]: value
          }
        };
      }

      // Otherwise update nested section
      return {
        ...prev,
        [layout]: {
          ...prev[layout],
          [section]: {
            ...prev[layout][section],
            [field]: value
          }
        }
      };
    });

    // --- Live error handling with custom messages ---
    const errorMessages = {
      camp_name: "Campaign name is required",
      brand_name: "Brand name is required",
      domain: "Domain is required",
      creative_name: "Creative name is required",
      // Add more fields here if needed
    };

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      const errorKey = section ? `${section}.${field}` : field;

      if (!value || value.toString().trim() === "") {
        newErrors[errorKey] = errorMessages[field] || "This field is required";
      } else {
        delete newErrors[errorKey];
      }

      return newErrors;
    });
  };


  // const validateForm = () => {
  //   const currentData = formData[selectedLayout];
  //   const newErrors = {};

  //   //  Layout1 validation
  //   if (selectedLayout === "layout1" || selectedLayout === "layout2" || selectedLayout === "layout3" || selectedLayout === "layout4" || selectedLayout === "layout4B" || selectedLayout === "layout4C") {
  //     if (!currentData.camp_name?.trim())
  //       newErrors.camp_name = "Campaign name is required";

  //     if (!currentData.brand_name?.trim())
  //       newErrors.brand_name = "Brand name is required";

  //     if (!currentData.domain?.trim())
  //       newErrors.domain = "Domain is required";

  //     if (!currentData.creative_name?.trim())
  //       newErrors.creative_name = "Creative name is required";
  //   }

  //   return newErrors;
  // };

  const validateForm = () => {
    const currentData = formData[selectedLayout];
    const newErrors = {};

    const layoutsWithCommonValidation = [
      "layout1",
      "layout2",
      "layout3",
      "layout4",
      "layout4B",
      "layout4C",
      "layout6",
      "layout7",
      "layout5"
    ];

    if (layoutsWithCommonValidation.includes(selectedLayout)) {

      const requiredFields = {
        camp_name: "Campaign name is required",
        brand_name: "Brand name is required",
        domain: "Domain is required",
        creative_name: "Creative name is required",
      };

      Object.entries(requiredFields).forEach(([field, message]) => {
        if (!currentData?.[field]?.trim()) {
          newErrors[field] = message;
        }
      });

    }

    return newErrors;
  };


  const handleSave = async () => {
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setErrors(errors);   // store in parent
      return;
    }

    setErrors({});

    const userDetail = getUser();
    if(!userDetail){
       error("Please login to generate video creatives.");
      return;
    }

    try {
      const dataToSave = {
        layout: selectedLayout,
        data: formData[selectedLayout],
        timestamp: new Date().toISOString()
      };

      // return;
      loaderStart();

      const response = await api.post('/generate-video', dataToSave);

      loaderClose();
      if (response.data && response.data.success) {
        success('Creative saved successfully!');
        setTimeout(() => navigate("/creatives"), 1000);
      }

    } catch (err) {
      loaderClose();
      error(err?.response?.data?.message || err?.message || "Something went wrong");
    }
  };

  return (
    <div className="app">

      <div className="app-header">
        <h2 className='premium-page-title'>Video Editor Canvas <span className='text-xs text-gray-500 tracking-wide'>(Preview is a quick simulation. Final video may have minor visual differences.)</span></h2>
        <div className="header-controls">

          <div className="layout-selector">
            <label htmlFor="layout-dropdown">Layout:</label>

            <div className="layout-dropdown-wrapper">
              <select
                id="layout-dropdown"
                value={selectedLayout}
                onChange={(e) => {
                  setSelectedLayout(e.target.value)
                  setErrors({})
                }}
                className="layout-dropdown"
              >
                {selectedLayout === "contact" ? <option value="">Select Layout</option> : null}
                <option value="layout1">Layout 1 (Split View)</option>
                <option value="layout2">Layout 2 (Centered View)</option>
                <option value="layout3">Layout 3 (Ralph Lauren)</option>
                <option value="layout4">Layout 4 (L Shape)</option>
                {/* <option value="layout4B">Layout 4 - B (L Shape)</option> */}
                <option value="layout4C">Layout 5 (L Shape Timer)</option>
                <option value="layout6">Layout 6</option>
                <option value="layout7">Layout 7</option>
                <option value="layout5">Layout 8</option>
              </select>
              <span className="layout-arrow"> <ChevronDown /></span>
            </div>
          </div>
        </div>
      </div>

      {selectedLayout === "contact" ? (
        <div className="flex items-center justify-center min-h-[750px] p-8">

          {/* Content */}
          <div className="relative overflow-hidden max-w-xl w-full rounded-3xl shadow-2xl">

            {/* Background */}
            <div className="absolute inset-0">
              <img
                src={HeroBg}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overlay */}
            <div className="absolute inset-0" />

            {/* Actual Content */}
            <div className="relative z-10 p-10 text-center backdrop-blur-[2px]">

              <div className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center shadow-lg"
                style={{
                  background: "linear-gradient(90deg, #2f7cf7 0%, #4f60f3 45%, #6c3df0 100%)"
                }}>
                <span className="text-4xl">✨</span>
              </div>

              <h2 className="text-4xl font-bold text-black mb-4">
                Premium Video Creative
              </h2>

              <p className="text-gray-700 text-lg leading-8 mb-8">
                Contact our team to unlock this exclusive creative layout.
              </p>

              <button
                onClick={() => navigate("/contact")}
                style={{
                  background: "linear-gradient(90deg, #2f7cf7 0%, #4f60f3 45%, #6c3df0 100%)"
                }}
                className="px-7 py-3 rounded-xl transition-all duration-300 text-white font-semibold shadow-xl"
              >
                Contact Us
              </button>

            </div>
          </div>
        </div>

      ) : (
        <div className="app-content">

          <div className="canvas-outer">
            <div
              className="canvas-container"
              style={{
                // padding: `${formData[selectedLayout].canvas.padding}`,
                transform: `scale(${scale})`,
                transformOrigin: "center center",
                background: getCanvasBackground(formData[selectedLayout]?.canvas)
              }}
            >
              <VideoEditor
                layout={selectedLayout}
                data={formData[selectedLayout]}
              />
            </div>
          </div>

          <div className="form-container">
            <FormFields
              layout={selectedLayout}
              data={formData[selectedLayout]}
              onChange={handleFormChange}
              errors={errors}
              onSave={handleSave}
            />
          </div>
        </div>
      )}

    </div>
  );
}
